
import { Component, Vue } from 'vue-property-decorator'
import RegisterWrapper from '@/components/register/RegisterWrapper.vue'
import { OPEN_URL, IS_PRODUCTION } from '@/common/variables'

@Component({
  components: {
    RegisterWrapper
  }
})
export default class RegisterSuccess extends Vue {
  handlePerfect() {
    const url = IS_PRODUCTION ? 'https://appstore.datastory.com.cn/' : 'http://appstore.dev.datastory.com.cn/'
    window.location.href = url
  }

  handleBack() {
    const { redirect_url } = this.$route.query
    window.open((redirect_url as string | undefined) || OPEN_URL, '_self')
  }
}
